const ErrorMassage = ({ message }) => {
  return (
    <div className="flex justify-start">
      <p className="text-red-500 text-base">{message?.[0]}</p>
    </div>
  )
}

export default ErrorMassage